import { SettingsHeading } from "./SettingsHeading";
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export function SettingsShell({
  icon: Icon,
  title,
  description,
  children,
}: {
  icon: LucideIcon;
  title: string;
  description: string;
  children: ReactNode;
}) {
  return (
    <section className="min-w-0 flex-1 overflow-y-auto p-5 md:p-8">
      <div className="mx-auto max-w-5xl">
        <div className="mb-6">
          <SettingsHeading
            icon={Icon}
            title={title}
            description={description}
          />
        </div>
        {children}
      </div>
    </section>
  );
}
